import { Tag, TagInput, TagInputProps } from 'emblor'
import React, { forwardRef } from 'react'

import { classes } from '../utils'

const ChipInput = forwardRef<HTMLInputElement, TagInputProps>(
  ({ styleClasses, ...props }, ref) => {
    const [isFocused, setIsFocused] = React.useState(false)

    return (
      <TagInput
        ref={ref}
        styleClasses={{
          ...styleClasses,
          inlineTagsContainer: classes(
            'border-border-normal focus-visible:ring-focus-outline placeholder:text-foreground-subtle',
            {
              'outline !outline-2 !outline-offset-[-2px] !outline-focus-outline':
                isFocused,
            },
            styleClasses?.inlineTagsContainer,
          ),
          input: classes(
            'h-8 !outline-none !ring-0 text-base shadow-none text-foreground-normal',
            styleClasses?.input,
          ),
          tag: {
            body: 'rounded-md text-sm border border-border-normal bg-background-surface text-foreground-normal h-[unset] py-1',
            closeButton:
              'bg-transparent text-foreground-normal h-5 w-5 mx-1 focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-focus-outline focus:outline-focus-outline focus:outline-2 focus:outline-offset-[-2px] py-0 px-0',
            ...styleClasses?.tag,
          },
        }}
        {...props}
        inputProps={{
          ...props.inputProps,
          onFocus: (e) => {
            setIsFocused(true)
            props.inputProps?.onFocus?.(e)
          },
          onBlur: (e) => {
            setIsFocused(false)
            props.inputProps?.onBlur?.(e)
          },
          // @ts-expect-error: This should exist
          'data-testid': 'chipInput',
        }}
      />
    )
  },
)
ChipInput.displayName = 'ChipInput'

export { ChipInput }
export type { Tag as Chip }
